import { moduleName, resetStarted, resetWith } from '../state';
import { createCommand } from '../../utils';
import { roadSectionsFilterQuery, roadSectionsSortQuery } from '../queries';

export const InitReferenceCommand = createCommand(
    `${moduleName}/INIT_REFERENCE`,
    async (_, { dispatch, extra, getState }) => {
        dispatch(resetStarted());
        const roadSections = await extra.externalReference.loadRoadSections();
        const state = getState();

        let sort = roadSectionsSortQuery(state);
        if (sort.length === 0) {
            sort = extra.externalReferenceConfiguration.loadRoadSectionsSort();
        }
        let filter = roadSectionsFilterQuery(state);
        if (filter.items.length === 0) {
            filter = extra.externalReferenceConfiguration.loadRoadSectionsFilter();
        }
        dispatch(resetWith({ roadSections, sort, filter }));
    },
);
